import * as React from "react";
import { SubMenu as UISubMenu, SubMenuProps } from "@stemscopes/ui";

// UI SubMenu has trouble with accesability, if some child equal undefined/false/null
const SubMenu: React.FC<SubMenuProps> = ({ children, ...rest }) => (
  <UISubMenu {...rest}>
    {React.Children.toArray(children).filter(Boolean)}
  </UISubMenu>
);

export default SubMenu;
